import React, { useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import { useDispatch, useSelector } from 'react-redux'
import { FindReplaceOutlined, SearchOutlined } from '@material-ui/icons'
import { Button, Tooltip } from '@material-ui/core'

import Products from './products'
import SitesFilter from './sites'
import AssetsFilter from './assets'
import { useStyles } from './styles'
import DateFilters from './date_ranges'
import ExportToExcel from '../exportToExcel'
import {
  getSitesControlPanel,
  getAssetsControlPanel,
} from '../../../api/controlPanel'
import {
  setAssetsControlPanel,
  setSitesControlPanel,
  setDateRangeControlPanel,
  setProductsControlPanel,
  setAssetNameFilterControlPanel,
  setSearchAssetsBySitesFlag,
  setSearchSitesByAssetsFlag,
  setSelectedAssetsFilterControlPanel,
  setSelectedSitesFilterControlPanel,
  setSiteNameFilterControlPanel,
  setActivateFilterFlag,
} from '../../../store/actions/controlPanel'
import { products } from '../../../constants/production-panel'
import { getLast30DaysFromToday, getTodayDate } from '../../../utils/dates'
import { checkForOnlySpacesString } from '../../../utils/productionPanel'
import { setHandleAlert } from '../../../store/actions/common'

const Filters = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const userData = useSelector(({ multitenantUser }) => ({
    accessToken: multitenantUser.accessToken,
    tenantId: multitenantUser.tenants?.find((t) => t.selected)?.id || 0,
  }))
  const sitesList = useSelector((state) => state.controlPanel.sitesList)
  const assetsList = useSelector((state) => state.controlPanel.assetsList)
  const activateFilterFlag = useSelector(
    (state) => state.controlPanel.activateFilterFlag
  )
  const siteNameFromRedux = useSelector((state) => state.controlPanel.siteName)
  const assetNameFromRedux = useSelector(
    (state) => state.controlPanel.assetName
  )
  const { oil, water, gas } = products
  const defaulRangeWithFormat = [
    getLast30DaysFromToday(),
    getTodayDate('YYYY-MM-DD'),
  ]

  useEffect(() => {
    if (!activateFilterFlag) {
      setFiltersToDefault()
      dispatch(setActivateFilterFlag())
    }
  }, [activateFilterFlag])

  useEffect(() => {
    const onlyWhitespaces = checkForOnlySpacesString(siteNameFromRedux)
    if (siteNameFromRedux && !onlyWhitespaces) {
      const siteName = encodeURIComponent(siteNameFromRedux.trim())
      getSitesControlPanelFuntion(siteName)
    }
    if (!siteNameFromRedux || onlyWhitespaces) {
      getSitesControlPanelFuntion('`')
      onlyWhitespaces &&
        showAlertMessage(
          'The search text cannnot contain only whitespaces',
          true,
          'warning'
        )
    }
  }, [siteNameFromRedux])

  useEffect(() => {
    const onlyWhitespaces = checkForOnlySpacesString(assetNameFromRedux)
    if (assetNameFromRedux && !onlyWhitespaces) {
      const assetName = encodeURIComponent(assetNameFromRedux.trim())
      getAssetsControlPanelFunction(assetName)
    }
    if (!assetNameFromRedux || onlyWhitespaces) {
      getAssetsControlPanelFunction('`')
      onlyWhitespaces &&
        showAlertMessage(
          'The search text cannnot contain only whitespaces',
          true,
          'warning'
        )
    }
  }, [assetNameFromRedux])

  const getAssetsControlPanelFunction = (assetName) => {
    if (userData?.accessToken) {
      getAssetsControlPanel(userData.accessToken, userData.tenantId, assetName)
        .then((response) => {
          dispatch(setAssetsControlPanel(response.data))
        })
        .catch((error) => {
          showAlertMessage('Something wrong happened', true, 'error')
        })
    }
  }

  const getSitesControlPanelFuntion = (siteName) => {
    if (userData?.accessToken) {
      getSitesControlPanel(userData.accessToken, userData.tenantId, siteName)
        .then((response) => {
          dispatch(setSitesControlPanel(response.data))
        })
        .catch((error) => {
          showAlertMessage('Something wrong happened', true, 'error')
        })
    }
  }

  const showAlertMessage = (message, status, severity) => {
    dispatch(
      setHandleAlert({
        message,
        status,
        severity,
      })
    )
  }

  const handleFiltersClick = () => {
    dispatch(setActivateFilterFlag())
  }

  const setFiltersToDefault = () => {
    dispatch(setSitesControlPanel([]))
    dispatch(setAssetsControlPanel([]))
    dispatch(setDateRangeControlPanel(defaulRangeWithFormat))
    dispatch(setProductsControlPanel([oil.value, water.value, gas.value]))
    dispatch(setAssetNameFilterControlPanel(''))
    dispatch(setSearchAssetsBySitesFlag(false))
    dispatch(setSearchSitesByAssetsFlag(false))
    dispatch(setSelectedAssetsFilterControlPanel([]))
    dispatch(setSelectedSitesFilterControlPanel([]))
    dispatch(setSiteNameFilterControlPanel(''))
  }

  const handleClearFilters = () => {
    setFiltersToDefault()
    dispatch(setActivateFilterFlag())
  }

  return (
    <div className={classes.container}>
      <Grid
        container
        spacing={2}
        justifyContent="space-evenly"
        alignContent="center"
      >
        <Grid item xs={2} md={2}>
          <SitesFilter
            options={sitesList}
            label="Sites"
            placeholder="Type for filter sites"
          />
        </Grid>
        <Grid item xs={2} md={2} xl={2} lg={2}>
          <AssetsFilter
            options={assetsList}
            label="Assets"
            placeholder="Type for filter assets"
          />
        </Grid>
        <Grid item xs={2} md={2} xl={2} lg={2}>
          <DateFilters />
        </Grid>
        <Grid item xs={2} md={2} xl={2} lg={2}>
          <Products />
        </Grid>
        <Grid item xs={3} md={3} xl={3} lg={3}>
          <Tooltip title="Search with current filters" placement="bottom">
            <Button
              size="small"
              color="primary"
              variant="outlined"
              onClick={handleFiltersClick}
              startIcon={<SearchOutlined />}
              className={classes.activateFiltersButton}
              id={`activateFiltersButton`}
            >
              Filter
            </Button>
          </Tooltip>
          <Tooltip title="Clear filters" placement="bottom">
            <Button
              size="small"
              variant="outlined"
              className={classes.cleanFiltersButton}
              onClick={handleClearFilters}
              startIcon={<FindReplaceOutlined />}
              id={`clearFiltersButton`}
            >
              Clear
            </Button>
          </Tooltip>
          <ExportToExcel />
        </Grid>
      </Grid>
    </div>
  )
}

export default Filters
